import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/Services/authentication.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { SharedService } from 'src/app/Services/shared.service';
import { getBrand } from 'src/environments/brand';

@Component({
  selector: 'ze-reset-password-view',
  templateUrl: './reset-password-view.component.html',
  styleUrls: ['./reset-password-view.component.scss']
})
export class ResetPasswordViewComponent implements OnInit {
  brand = getBrand();

  token: string;
  public form: FormGroup;
  loading = false;
  returnUrl: string = '/login';
  error = '';
  isValidToken: boolean = true;
  public passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,}$/;

  constructor(private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private _sharedService: SharedService,
    private router: Router,
    private notifyService: NotifyService) { 
      this.formInit();
    }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.authenticationService.isResetTokenValid(this.token).subscribe(data => {
        this.isValidToken = data;
      })
    });
  }

  private formInit() {
    this.form = this.formBuilder.group({
      newPassword: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
      confirmNewPassword: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
    }, { validator: this.checkingPasswords });
  }

  public checkingPasswords(formGroup: FormGroup) {
    if (
      formGroup.controls.newPassword.value &&
      formGroup.controls.confirmNewPassword.value &&
      formGroup.controls.newPassword.value.length >= 8
    ) {
      return formGroup.controls.newPassword.value === formGroup.controls.confirmNewPassword.value ? false : { "notMatched": true }
    }
    return false;
  }

  checkPasswordValidations(): boolean {
    return (!this.form.controls.newPassword.pristine && this.form.controls.newPassword.errors && this.form.controls.newPassword.errors.pattern) 
    || (!this.form.controls.confirmNewPassword.pristine && this.form.controls.confirmNewPassword.errors && this.form.controls.confirmNewPassword.errors.pattern);
  }

  resetPassword(): void {
    this.loading = true;
    this._sharedService.loaderHide.emit(true);
    this.authenticationService.resetPassword(this.token, this.form.controls.newPassword.value).subscribe(
      data => {
        this.error = '';
        this.loading = false;
        this._sharedService.loaderHide.emit(false);
        this.notifyService.notify('success', 'Success', "Password reset successfully");
        this.router.navigateByUrl(this.returnUrl);
      },
      error => {
        this.error = error == 'Invalid Token' ? 'Incorrect Token. Retry with valid reset link' : error;
        this.loading = false;
        this._sharedService.loaderHide.emit(false);
        this.notifyService.notify('error', 'Failed', this.error);
      }
    );
  }

}
